import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { initOneSignal, osLogin, osLogout } from "../lib/push";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    initOneSignal();
  }, []);

  useEffect(() => {
    if (user?.id) osLogin(user.id);
  }, [user?.id]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    osLogout();
    setUser(null);
  }, []);

  const googleLogin = useCallback(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, logout, googleLogin, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
